var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorites container p-0"},[_c('vue-headful',{attrs:{"title":'My Bookmarks'}}),_vm._v(" "),_c('h2',{staticClass:"colored-text form-title"},[_vm._v("My Bookmarks")]),_vm._v(" "),_c('div',{staticClass:"row"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76259710","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Favorites.vue
// module id = 142
// module chunks = 0